import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  private APP_KEY = 'videoconference_key_';

  /**
   * Retrieves the storage data associated with the provided key
   * @param key: string
   */
  get(key: string): any {
    return this.fromStorage(sessionStorage.getItem(this.APP_KEY + key) || '');
  }

  /**
   * Sets the provided data using the provided key as reference on storage
   * @param key: string
   * @param value: any, and it will be stringified prior to be stored
   */
  set(key: string, value: any) {
    sessionStorage.setItem(this.APP_KEY + key, this.toStorage(value));
  }

  toStorage(data: any): string{
    return JSON.stringify(data);
  }

  fromStorage(data: string): any {
    try{
      return JSON.parse(data);
    }catch(err){
      return null;
    }
  }

  /**
   * Removes storage data associated to given key
   * @param key: string
   */
  remove(key: string) {
    sessionStorage.removeItem(this.APP_KEY + key);
  }

  /**
   * Clears all the data currently on storage
   */
  clear() {
    sessionStorage.clear();
  }
}
